export enum ActionTypes {
  StartEditing = 'StartEditing',
  MouseClick = 'MouseClick',
  Reset = 'Reset',
  TransformEnd = 'TransformEnd'
}
type ActionType = {
  type: ActionTypes;
};

type StateType = {
  isTransforming: boolean;
  isEditing: boolean;
  updateText: boolean;
};

export const reducer = (state: StateType, action: ActionType) => {
  switch (action.type) {
    case ActionTypes.MouseClick: {
      return {
        ...state,
        isTransforming: true
      };
    }
    case ActionTypes.Reset: {
      return {
        isTransforming: false,
        isEditing: false,
        updateText: false
      };
    }
    case ActionTypes.TransformEnd: {
      return {
        ...state,
        isTransforming: false
      };
    }
    case ActionTypes.StartEditing: {
      return {
        isEditing: true,
        isTransforming: false,
        updateText: true
      };
    }
    default:
      break;
  }
};
